import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { getBehaviorCategoryDetails, saveBehaviorCategory } from './actions/behaviourCategoryActions';
import { isValidNameWithSpace, renderCheckBox, renderTextField, renderTextArea } from '../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../components/buttons';
import SmallLoader from '../../../img/small-loader.gif';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError } from '../../../actions/utilAction';



class BehaviorCategoryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      behaviorCategoryId: props.behaviorCategoryId
    };
  }

  componentWillMount() {
    if (this.state.behaviorCategoryId) {
      this.props.getBehaviorCategoryDetails(this.state.behaviorCategoryId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    let postData = {
      "id": this.props.behaviorCategoryId || 0,
      "behaviorCategoryName": formProps.behaviorCategoryName,
      "description": formProps.description,     
      "isActive":  formProps.isActive || false
    }
    this.props.clearFieldErrorArray();
    this.props.saveBehaviorCategory(postData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.behaviorCategoryId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
    <SubmitButtonModalDisabled label="Loading" /> :
    <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
        submitButton,
      ];
    return (
      <Dialog
        className="custom_modal"
        title={
          this.state.behaviorCategoryId
            ? "Edit Behavior Category"
            : "Add Behavior Category"
        }
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="behaviorCategoryName"
                    type="text"          
                    onChange={(input, value) => this.checkFieldDataExistence(input, value, 'Behavior Category Name')}
                    customError={displayCustomError('BEHAVIORCATEGORYNAME', this.props.fieldError)}        
                    maxLength="250"
                    label="Behavior Category Name"
                    normalize={isValidNameWithSpace}
                    component={renderTextField}
                  />
                </div>
                <div className="col-sm-12 mt-20">
                <Field
                    name="description"
                    type="text"
                    maxLength="1000"
                    label="Description"
                    // normalize ={isValidNameWithSpace}
                    component={renderTextArea} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field
                    className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

BehaviorCategoryModal = reduxForm({
    form: 'BehaviorCategoryModalForm',
    validate,
    enableReinitialize: true,
})(BehaviorCategoryModal);


function mapStateToProps(state, ownProps) { 
  let initialValueData = {
    isActive: true,
  };

  if (ownProps.behaviorCategoryId && state.behaviorCategory.behaviorCategoryListDetails) {
    initialValueData = state.behaviorCategory.behaviorCategoryListDetails.data || null;
  } 

  return {
    loading: state.behaviorCategory.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  }
}

export default connect(mapStateToProps,{getBehaviorCategoryDetails, checkFieldExistence, clearFieldErrorArray, saveBehaviorCategory})(BehaviorCategoryModal);



// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/behaviourCategory/behaviorCategory_Modal.js